import { useState, useEffect } from 'react';

function EditMainClaim(props) {

	const [editedMainClaim, setEditedMainClaim] = useState("");
	const isMainClaimValid = editedMainClaim && editedMainClaim.length >= 20 ? true : false;

	const style = {
		button: "py-1.5 px-5 rounded font-bold text-white",
	};

	useEffect(() => {
		if (props.mainClaim) {
			setEditedMainClaim(props.mainClaim);
		}
	}, [props.mainClaim]);


	function handleEditMainClaim(event) {
		setEditedMainClaim(event.target.value);
	}

	function handleUpdateMainClaim() {
		if (isMainClaimValid) {
			props.updateMainClaim(editedMainClaim);
		}
	}

	return (
		<>
			<textarea
				className="m-2 p-2 w-[95%] border-2 border-slate-400 rounded-md"
				value={editedMainClaim}
				onChange={handleEditMainClaim}>
			</textarea>
			{!isMainClaimValid ? <div className="text-red-600">Main claim must be at least 20 characters in length</div> : null}
			<div className="flex justify-center gap-5 pt-2">
				<button className={`${style.button} cursor-pointer bg-blue-600 hover:bg-blue-700`} onClick={handleUpdateMainClaim}>
					Update
				</button>
				<button className={`${style.button} cursor-pointer bg-red-600 hover:bg-red-700`} onClick={props.switchEditing}>
					Cancel
				</button>
			</div>
		</>
	)

}

export default EditMainClaim;
